export default __webpack_public_path__ + "static/media/lamp2.dc780d50.png";